import React, { useState, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import MantenimientosTable from './shared/MantenimientosTable';
import MantenimientoSlideOver from './MantenimientoSlideOver';
import { categorizar } from './shared/useFlota';

export default function EnCursoPage() {
  const { mantenimientos, isLoading, refetch } = useOutletContext();
  const [detalleId, setDetalleId] = useState(null);

  const rows = useMemo(() => categorizar(mantenimientos).enCurso, [mantenimientos]);

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography sx={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>Mantenimientos en curso</Typography>
        <Typography sx={{ fontSize: 12, color: '#64748b' }}>
          {rows.length} tarea(s) actualmente en ejecución.
        </Typography>
      </Box>

      <MantenimientosTable rows={rows} loading={isLoading}
        onRowClick={r => setDetalleId(r.id)}
        showProveedor
        emptyTitle="Sin tareas en curso"
        emptyMessage="Cuando inicies un mantenimiento, aparecerá aquí." />

      {detalleId && (
        <MantenimientoSlideOver mantenimientoId={detalleId}
          onClose={() => setDetalleId(null)} onUpdated={refetch} />
      )}
    </Box>
  );
}
